export default {
  ORDER_DETAILS: {
    ORDERING_RETAILERS: 'ordering_retailers',
    ORDERING_LICENSES: 'ordering_licenses',
    ORDERING_ENFORCEMENT: 'ordering_enforcements',
    ORDERING: 'ordering',
  },
};
